import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

export const RoadWorkReportCompleteTableDataAPI = createAsyncThunk("RoadWorkReportCompleteTableData", async ({ data }) => {
    const {
        M_WardID,
        FromDate,
        ToDate,
        UserID,
        token,
        Flag,
        From,
        To,
        handleGetPdfUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_T_KPI_RM_WorkProgressCompleted_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_UsersID=${UserID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPdfUrl && handleGetPdfUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const RoadWorkReportCompleteTableDataSlice = createSlice({
    name: "RoadWorkReportCompleteTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoadWorkReportCompleteTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoadWorkReportCompleteTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(RoadWorkReportCompleteTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const RoadWorkReportCompleteTableDataReducer = RoadWorkReportCompleteTableDataSlice.reducer

// PDF Export File

export const RoadWorkReportCompleteTablePDFDataAPI = createAsyncThunk("RoadWorkReportCompleteTablePDFData", async ({ data }) => {
    const {
        M_WardID,
        FromDate,
        ToDate,
        UserID,
        token,
        Flag,
        From,
        To,
        handleGetPdfUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_T_KPI_RM_WorkProgressCompleted_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_UsersID=${UserID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPdfUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const RoadWorkReportCompleteTablePDFDataSlice = createSlice({
    name: "RoadWorkReportCompleteTablePDFData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoadWorkReportCompleteTablePDFDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoadWorkReportCompleteTablePDFDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(RoadWorkReportCompleteTablePDFDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const RoadWorkReportCompleteTablePDFDataReducer = RoadWorkReportCompleteTablePDFDataSlice.reducer




export const RoadWorkReportCompleteTableDataPDFAPI = createAsyncThunk("RoadWorkReportCompleteTableDataPDF", async ({ data }) => {
    const {
        M_WardID,
        FromDate,
        ToDate,
        UserID,
        token,
        Flag,
        From,
        To,
        setPDFloader,
        handleGetPdfUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    setPDFloader(true)
    return fetch(`${BaseUrl}/APKDashboard/Get_RM_T_KPI_RM_WorkProgressCompleted_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_UsersID=${UserID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPdfUrl && handleGetPdfUrl(result.url)
                setPDFloader(false)
                return result.data
            } else {
                setPDFloader(false)
                return result
            }
        })
})

const RoadWorkReportCompleteTableDataPDFSlice = createSlice({
    name: "RoadWorkReportCompleteTableDataPDF",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoadWorkReportCompleteTableDataPDFAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoadWorkReportCompleteTableDataPDFAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(RoadWorkReportCompleteTableDataPDFAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const RoadWorkReportCompleteTableDataPDFReducer = RoadWorkReportCompleteTableDataPDFSlice.reducer